import { useEffect, useState } from "react";
import { api } from "@/api";
import { useLang } from "@/i18n";

/**
 * Fascia di prezzo indicativa live dal backend: tappe + km reali (Google) +
 * partecipanti (+ notti/esperienze per l'Italia). Null finché non disponibile.
 */
export const useEstimate = (mode, { stops, km, participants, nights = 0, experiences = 0 }) => {
    const [est, setEst] = useState(null);
    const signature = `${mode}|${stops}|${Math.round(km)}|${participants}|${nights}|${experiences}`;

    useEffect(() => {
        if (stops < 1) {
            setEst(null);
            return undefined;
        }
        const timer = setTimeout(() => {
            api.post("/public/builder/estimate", {
                mode,
                stops,
                km: Math.round(km * 10) / 10,
                participants,
                nights,
                experiences,
            }).then((r) => setEst(r.data?.available ? r.data : null))
                .catch(() => setEst(null));
        }, 450);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [signature]);

    return est;
};

const fmtEur = (v) => `€ ${Number(v).toLocaleString("it-IT")}`;

/** Riga riepilogo con la fascia indicativa (oro). data-testid="estimate-range". */
export const EstimateRow = ({ estimate }) => {
    const { t } = useLang();
    if (!estimate) return null;
    return (
        <div className="flex justify-between text-sm pt-3" data-testid="estimate-block">
            <span className="text-stone-400">{t.builder.estTitle}</span>
            <span className="font-semibold text-amber-300" data-testid="estimate-range">{fmtEur(estimate.min)} – {fmtEur(estimate.max)}</span>
        </div>
    );
};
